import raw from './standardsAndSources.json';

export interface StandardsSourceLink {
  title: string;
  link: string;
  description: string;
}

export interface StandardsSourceGroup {
  name: string;
  items: StandardsSourceLink[];
}

interface StandardsAndSourcesFile {
  [region: string]: { groups: StandardsSourceGroup[] };
}

const data = raw as StandardsAndSourcesFile;

// One level of grouping, one level of links — groups and their items render
// in the exact order given in the file, never re-sorted. Region-hardcoded
// for now (per-hit jurisdiction, e.g. a source list's own country code);
// falls back to "default" for a region with no dedicated entry. Keys are
// ISO 3166-1 alpha-2 (e.g. "US", "AR") to match the real `region` values
// AmethystClient returns — confirmed against a live case, which showed
// "MX". Previously kept as alpha-3 ("USA"/"ARG"), which a real region
// value would never match.
export function standardsForRegion(region: string): StandardsSourceGroup[] {
  return (data[region] ?? data.default)?.groups ?? [];
}
